'use client'
import React, { useState, Fragment } from 'react'
import { Modal, Tabs, Tab } from 'react-bootstrap'
import { notification } from 'antd';
import { CustomNumber, CustomSelect, CustomTextarea } from '../reuse/FormControls'
import { addBr, colorsList, getBr, getHtml } from '../../helper'
import { updateAdditionalExp } from '../../services/directorServices';

export default function ExperienceModal({
  experienceModal,
  closeModal,
  programId,
  onUpdate,
  additionalExp,
}) {
  const [aEList, setAEList] = useState(additionalExp ?? []);
  const [isEditing, setIsEditing] = useState(false);
  const [activeTab, setActiveTab] = useState('0')
  const [editingIndex, setEditingIndex] = useState(null)
  const [newQuestion, setNewQuestion] = useState(null);
  const [addingNew, setAddingNew] = useState(false)
  const [maxAdditionalExpCount, setMaxAdditionalExpCount] = useState('');
  const [remainingAdditionalExpCount, setRemainingAdditionalExpCount] = useState('');
  const [remainingAdditionalExpCountTemp, setRemainingAdditionalExpCountTemp] = useState('');


  const [title, setTitle] = useState('');
  const [price, setPrice] = useState('');
  const [description, setDescription] = useState('');
  const [titleError, setTitleError] = useState('');
  const [priceError, setPriceError] = useState('');
  const [descriptionError, setDescriptionError] = useState('');
  const [color, setColor] = useState('');
  const [colorErr, setColorErr] = useState('');
  const [maxAdditionalExpCountErr, setMaxAdditionalExpCountErr] = useState('');
  const [btnLoadeer, setBtnLoadeer] = useState(false);

  const questionTypes = [
    { label: 'Short Answer', value: 1 },
    { label: 'Drop-down', value: 2 },
    // {label: 'Multiple Choice', value: 3},
    { label: 'Checkboxes', value: 4 },
  ];

  const resetFormState = () => {
    setTitle('');
    setPrice('');
    setDescription('');
    setColor('');
    setTitleError('');
    setPriceError('');
    setDescriptionError('');
    setColorErr('');
    setMaxAdditionalExpCount('');
    setRemainingAdditionalExpCount('');
    setMaxAdditionalExpCountErr('');
    setNewQuestion({
      title: '',
      subTitle: '',
      questionType: '',
      isRequred: 0,
      isOtherOption: 0,
      options: [],
      optionVal: '',
    });
  };

  const handleAddNewExperience = () => {
    resetFormState();
    setAddingNew(true);
    setEditingIndex(null);
    setActiveTab('new');
    setIsEditing(true);
  }

  const handleEdit = (index) => {
    setEditingIndex(index)
    setActiveTab(String(index))
    handleEditAEList(aEList[index])

    setIsEditing(true);
  }

  const handleCancelEdit = () => {
    setEditingIndex(null)
    setAddingNew(false);
    // If we were adding a new one, switch back to the first tab
    if (activeTab === 'new') {
      setActiveTab('0');
    }
    setIsEditing(false);
  }

  const handleSaveNew = (e) => {
    e.preventDefault()
    handleAddOrUpdate(newQuestion)
    setIsEditing(false);
  }

  const handleEditAEList = item => {
    setTitle(getBr(item.title));
    setPrice(item.price);
    setDescription(getBr(item.description));
    setColor(item.color);
    setMaxAdditionalExpCount(item.maxAdditionalExpCount);
    setRemainingAdditionalExpCount(item.remainingAdditionalExpCount);
    setRemainingAdditionalExpCountTemp(item.maxAdditionalExpCount - item.remainingAdditionalExpCount);
  }

  const handleDeleteAEList = index => {
    setAEList(prev => prev.filter((_, i) => i !== index));
  }

  const handleAddOrUpdate = (newQuestionPayload) => {
    if (!validateForm()) return;

    if (editingIndex !== null) { // Updating existing
      const updatedList = [...aEList];
      const currentItem = updatedList[editingIndex];
      updatedList[editingIndex] = {
        ...currentItem,
        price,
        description: addBr(description),
        title: addBr(title),
        color,
        maxAdditionalExpCount,
        remainingAdditionalExpCount,
        isAddexpRequred: currentItem.isAddexpRequred ?? 0,
      };
      setAEList(updatedList);
    } else { // Adding new
      const newItem = {
        price,
        description: addBr(description),
        title: addBr(title),
        color,
        maxAdditionalExpCount,
        remainingAdditionalExpCount,
        question: newQuestionPayload,
      };
      setAEList(prev => [...prev, newItem]);
      setActiveTab(String(aEList.length));
    }

    resetFormState();
    setEditingIndex(null);
    setAddingNew(false);
    setIsEditing(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onUpdate(aEList);
  };

  const validateForm = () => {
    let isValid = true;
    if (!title.trim()) { setTitleError('Title is required'); isValid = false; }
    if (price === '' || price === null) { setPriceError('Price is required'); isValid = false; }
    if (maxAdditionalExpCount === '' || maxAdditionalExpCount === null) { setMaxAdditionalExpCountErr('Total slots is required'); isValid = false; }
    if (!description.trim()) { setDescriptionError('Description is required'); isValid = false; }
    return isValid;
  };

  const handleExpCountChange = (value) => {
    setMaxAdditionalExpCountErr('');
    if (remainingAdditionalExpCountTemp) {
      if (value < remainingAdditionalExpCountTemp) {
        setMaxAdditionalExpCountErr('Total slots cannot be less than already booked slots.');
      } else {
        setMaxAdditionalExpCount(value);
        setRemainingAdditionalExpCount(value - remainingAdditionalExpCountTemp);
      }
    } else {
      setMaxAdditionalExpCount(value);
      setRemainingAdditionalExpCount(value);
    }
  };

  // --- Question Handlers ---
  const getQuestionType = value => questionTypes.find(i => i.value === value);

  const handleAddQuestion = index => {
    const updatedList = [...aEList];
    updatedList[index].question = { questionType: '', title: '', subTitle: '', optionVal: '', options: [], isRequred: 0, isOtherOption: 0 };
    setAEList(updatedList);
  };

  const handleQuestionTypeChange = (e, index) => {
    const updatedList = [...aEList];
    updatedList[index].question.questionType = e.value;
    setAEList(updatedList);
  };

  const handleIsRequredChnage = index => {
    const updatedList = [...aEList];
    updatedList[index].question.isRequred = updatedList[index].question.isRequred === 1 ? 0 : 1;
    setAEList(updatedList);
  };

  const handleMandatoryAddexpChnage = index => {
    const updatedList = [...aEList];
    updatedList[index].isAddexpRequired = updatedList[index].isAddexpRequired === 1 ? 0 : 1;
    setAEList(updatedList);
  };

  const handleIsOtherOptionChnage = index => {
    const updatedList = [...aEList];
    updatedList[index].question.isOtherOption = updatedList[index].question.isOtherOption === 1 ? 0 : 1;
    setAEList(updatedList);
  };

  const handleQuestionChange = (e, index) => {
    const updatedList = [...aEList];
    updatedList[index].question.title = e.target.value;
    setAEList(updatedList);
  };

  const handleQuestionSubTitleChange = (e, index) => {
    const updatedList = [...aEList];
    updatedList[index].question.subTitle = e.target.value;
    setAEList(updatedList);
  };

  const handleOptionValChange = (e, index) => {
    const updatedList = [...aEList];
    updatedList[index].question.optionVal = e.target.value;
    updatedList[index].question.optionValErr = '';
    setAEList(updatedList);
  };

  const handleAddOption = (index) => {
    const updatedList = [...aEList];
    const question = updatedList[index].question;
    if (question.optionVal && question.optionVal.trim()) {
      question.options.push({ opt: question.optionVal });
      question.optionVal = '';
      setAEList(updatedList);
    }
  };

  const handleRemoveOption = (index, childIndex) => {
    const updatedList = [...aEList];
    updatedList[index].question.options.splice(childIndex, 1);
    setAEList(updatedList);
  };

  const handleNewQuestionChange = (e, field) => {
    setNewQuestion(prev => ({ ...prev, [field]: e.target.value }));
  };

  const handleNewQuestionTypeChange = (e) => {
    setNewQuestion(prev => ({ ...prev, questionType: e.value }));
  };

  const handleNewIsRequiredChange = () => {
    setNewQuestion(prev => ({ ...prev, isRequred: prev.isRequred === 1 ? 0 : 1 }));
  };

  const handleNewIsOtherOptionChange = () => {
    setNewQuestion(prev => ({ ...prev, isOtherOption: prev.isOtherOption === 1 ? 0 : 1 }));
  };

  const handleNewOptionValChange = (e) => {
    setNewQuestion(prev => ({ ...prev, optionVal: e.target.value, optionValErr: '' }));
  };

  const handleAddNewOption = () => {
    if (!newQuestion.optionVal.trim()) {
      setNewQuestion(prev => ({ ...prev, optionValErr: 'Option cannot be empty' }));
      return;
    }
    setNewQuestion(prev => ({
      ...prev,
      options: [...prev.options, { opt: prev.optionVal }],
      optionVal: '',
      optionValErr: '',
    }));
  };

  const handleRemoveNewOption = (optIndex) => {
    setNewQuestion(prev => ({
      ...prev,
      options: prev.options.filter((_, i) => i !== optIndex),
    }));
  }
  return (
    <Modal
      size="lg"
      show={experienceModal}
      dialogClassName="remove_header_line"
      animation={false}
      centered
    >
      <Modal.Header>
        <Modal.Title>Additional Experiences</Modal.Title>
        <span className="modal_close" onClick={closeModal}>
          <i className="icon-cross" />
        </span>
      </Modal.Header>

      <Modal.Body>
        <Tabs
          id="experience-tabs"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className={`mb-4 ${isEditing ? 'tabs-disabled' : ''}`}
        >
          {/* Existing experiences */}
          {aEList.map((item, index) => (
            <Tab
              key={index}
              eventKey={String(index)}
              title={`Experience ${index + 1}`}
            >
              {editingIndex !== index ? ( // View Mode
                <div className="schedule_item mt-3">
                  <h6 style={{ color: item.color }} className="mb-2">
                    <b>Title:</b> {getHtml(item.title)}
                  </h6>
                  <p style={{ color: item.color }} className="mb-2">
                    <b>Price:</b> ${item.price.toFixed(2)}
                  </p>
                  <p style={{ color: item.color }} className="mb-2">
                    <b>Total Slots:</b> {item.maxAdditionalExpCount}
                  </p>
                  <p style={{ color: item.color }} className="mb-2">
                    <b>Available Slots:</b> {item.remainingAdditionalExpCount}
                  </p>
                  <p style={{ color: item.color }} className="mb-2">
                    <b>Description:</b> {getHtml(item.description)}
                  </p>

                  <div className="cm_action mt-3 addexp_action_row">

                      <div className="icons_group">
                          <i className="icon-delete" onClick={() => handleDeleteAEList(index)} />
                          <i className="icon-pancil" onClick={() => handleEdit(index)} />
                      </div>

                      <p>Is Mandatory?</p>

                      <label className="addexp_switch">
                          <input
                              type="checkbox"
                              checked={item.isAddexpRequired === 1}
                              onChange={() => handleMandatoryAddexpChnage(index)}
                          />
                          <span></span>
                      </label>

                  </div>

                  {/* Question Section */}
                  {item.question ? (
                    <div className="form-group cm_questions cm_questions2 mt-4">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <label>Question</label>
                        <span className="question_types me-0">
                          {(item.question.questionType === 3 ||
                            item.question.questionType === 4) && (
                              <Fragment>
                                <p>Is Other Option ?</p>
                                <div className="cm_swich_wrap">
                                  <input
                                    onChange={() => handleIsOtherOptionChnage(index)}
                                    type="checkbox"
                                    checked={item.question.isOtherOption === 1}
                                  />
                                  <span />
                                </div>
                              </Fragment>
                            )}

                          <p>Is Mandatory ?</p>
                          <div className="cm_swich_wrap">
                            <input
                              type="checkbox"
                              checked={item.question.isRequred === 1}
                              onChange={() => handleIsRequredChnage(index)}
                            />
                            <span />
                          </div>

                          <CustomSelect
                            pHolder="Select Question Type"
                            value={getQuestionType(item.question.questionType)}
                            onChange={(e) => handleQuestionTypeChange(e, index)}
                            options={questionTypes}
                          />
                        </span>
                      </div>

                      {item.question.questionType ? (
                        <div className="cm_ques">
                          <CustomTextarea
                            pHolder="Question*"
                            value={item.question.title}
                            change={(e) => handleQuestionChange(e, index)}
                          />
                          <CustomTextarea
                            pHolder="Sub Title"
                            value={item.question.subTitle}
                            change={(e) => handleQuestionSubTitleChange(e, index)}
                          />
                        </div>
                      ) : null}

                      {(item.question.questionType === 2 ||
                        item.question.questionType === 3 ||
                        item.question.questionType === 4) && (
                          <div className="cm_options mt-2">
                            {item.question.options.length ? (
                              <ul>
                                {item.question.options.map((itm, j) => (
                                  <li key={j}>
                                    {itm.opt}{' '}
                                    <i
                                      className="icon-close"
                                      onClick={() => handleRemoveOption(index, j)}
                                    />
                                  </li>
                                ))}
                              </ul>
                            ) : null}

                            <div className="d-flex align-items-center">
                              <input
                                type="text"
                                className={`form-control ${item.question.optionValErr ? 'is-invalid' : ''
                                  }`}
                                placeholder="Add Option"
                                value={item.question.optionVal}
                                onChange={(e) => handleOptionValChange(e, index)}
                              />
                              {item.question.optionValErr && (
                                <h6>{item.question.optionValErr}</h6>
                              )}
                              <div>
                                <span
                                  style={{ minWidth: '150px', marginLeft: '20px' }}
                                  className="btn btn-outline-primary btn-sm"
                                  onClick={() => handleAddOption(index)}
                                >
                                  <i className="icon-plus" />
                                  <small>Add</small>
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  ) : (
                    <div
                      className="add_question_btn mt-3"
                      onClick={() => handleAddQuestion(index)}
                    >
                      <i className="icon-plus" />
                      <small>Add Question</small>
                    </div>
                  )}
                </div>
              ) : (
                // Edit Mode
                <form onSubmit={(e) => { e.preventDefault(); handleAddOrUpdate(); }} className="mt-3">
                  <div className="form-group">
                    <label>Title</label>
                    <CustomTextarea
                      change={(e) => (setTitle(e.target.value), setTitleError(''))}
                      value={title}
                      pHolder="Title"
                      error={titleError}
                    />
                  </div>

                  <div className="row">
                    <div className="col form-group">
                      <label>Price</label>
                      <CustomNumber
                        formatter={(v) => `$${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        change={(e) => (setPrice(e), setPriceError(''))}
                        value={price}
                        pHolder="Price"
                        min={0}
                        precision={2}
                        error={priceError}
                      />
                    </div>

                    <div className="col form-group">
                      <label>Color</label>
                      <select
                        value={color}
                        className={`form-control ${colorErr ? 'is-invalid' : ''}`}
                        onChange={(e) => (setColor(e.target.value), setColorErr(''))}
                      >
                        <option value="">Select color</option>
                        {colorsList.map((colr) => (
                          <option key={colr} value={colr}>
                            {colr}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col form-group">
                      <label>Total Slots</label>
                      <CustomNumber
                        value={maxAdditionalExpCount}
                        error={maxAdditionalExpCountErr}
                        change={handleExpCountChange}
                        min={0}
                        precision={0}
                        step={1}
                        pHolder="Enter Total Slots" />

                    </div>

                    <div className="col form-group">
                      <label>Available Slots</label>
                      <CustomNumber
                        value={remainingAdditionalExpCount}
                        disabled />

                    </div>
                  </div>

                  <div className="form-group">
                    <label>Description</label>
                    <CustomTextarea
                      value={description}
                      change={(e) =>
                        (setDescription(e.target.value), setDescriptionError(''))
                      }
                      pHolder="Write Description here…"
                      error={descriptionError}
                    />
                  </div>

                  {/* --- Editable Question Section --- */}
                  {item.question ? (
                    <div className="form-group cm_questions cm_questions2 mt-4">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <label>Question</label>
                        <span className="question_types me-0">
                          {(item.question.questionType === 3 ||
                            item.question.questionType === 4) && (
                              <Fragment>
                                <p>Is Other Option ?</p>
                                <div className="cm_swich_wrap">
                                  <input
                                    onChange={() => handleIsOtherOptionChnage(index)}
                                    type="checkbox"
                                    checked={item.question.isOtherOption === 1}
                                  />
                                  <span />
                                </div>
                              </Fragment>
                            )}

                          <p>Is Mandatory ?</p>
                          <div className="cm_swich_wrap">
                            <input
                              type="checkbox"
                              checked={item.question.isRequred === 1}
                              onChange={() => handleIsRequredChnage(index)}
                            />
                            <span />
                          </div>

                          <CustomSelect
                            pHolder="Select Question Type"
                            value={getQuestionType(item.question.questionType)}
                            onChange={(e) => handleQuestionTypeChange(e, index)}
                            options={questionTypes}
                          />
                        </span>
                      </div>

                      {item.question.questionType ? (
                        <div className="cm_ques">
                          <CustomTextarea
                            pHolder="Question*"
                            value={item.question.title}
                            change={(e) => handleQuestionChange(e, index)}
                          />
                          <CustomTextarea
                            pHolder="Sub Title"
                            value={item.question.subTitle}
                            change={(e) => handleQuestionSubTitleChange(e, index)}
                          />
                        </div>
                      ) : null}

                      {(item.question.questionType === 2 ||
                        item.question.questionType === 3 ||
                        item.question.questionType === 4) && (
                          <div className="cm_options mt-2">
                            {/* Options list and add new option input */}
                            {/* This part is already implemented and can be reused */}
                          </div>
                        )}
                    </div>
                  ) : (
                    <div
                      className="add_question_btn mt-3"
                      onClick={() => handleAddQuestion(index)}
                    >
                      <i className="icon-plus" />
                      <small>Add Question</small>
                    </div>
                  )}
                  {/* --- End Editable Question Section --- */}

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <button
                      type="button"
                      className="btn btn-gray"
                      onClick={handleCancelEdit}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                      {editingIndex !== null ? 'Update' : 'Save'}
                    </button>
                  </div>
                </form>
              )}
            </Tab>
          ))}

          {/* Add new experience tab */}
          <Tab
            eventKey="new"
            title={
              <span onClick={handleAddNewExperience}>
                <i className="icon-plus" /> Add New
              </span>
            }
          >
            {addingNew && (
              <form onSubmit={handleSaveNew} className="mt-3">
                <div className="form-group">
                  <label>Title</label>
                  <CustomTextarea
                    change={(e) => (setTitle(e.target.value), setTitleError(''))}
                    value={title}
                    pHolder="Title"
                    error={titleError}
                  />
                </div>

                <div className="row">
                  <div className="col form-group">
                    <label>Price</label>
                    <CustomNumber
                      formatter={(v) => `$${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      change={(e) => (setPrice(e), setPriceError(''))}
                      value={price}
                      pHolder="Price"
                      min={0}
                      precision={2}
                      error={priceError}
                    />
                  </div>

                  <div className="col form-group">
                    <label>Color</label>
                    <select
                      value={color}
                      className={`form-control ${colorErr ? 'is-invalid' : ''}`}
                      onChange={(e) => (setColor(e.target.value), setColorErr(''))}
                    >
                      <option value="">Select color</option>
                      {colorsList.map((colr) => (
                        <option key={colr} value={colr}>
                          {colr}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="col form-group">
                    <label>Total Slots</label>
                    <CustomNumber
                      value={maxAdditionalExpCount}
                      error={maxAdditionalExpCountErr}
                      change={handleExpCountChange}
                      min={0}
                      precision={0}
                      step={1}
                      pHolder="Enter Total Slots" />

                  </div>

                  <div className="col form-group">
                    <label>Available Slots</label>
                    <CustomNumber
                      value={remainingAdditionalExpCount}
                      disabled />

                  </div>
                </div>

                <div className="form-group">
                  <label>Description</label>
                  <CustomTextarea
                    value={description}
                    change={(e) =>
                      (setDescription(e.target.value), setDescriptionError(''))
                    }
                    pHolder="Write Description here…"
                    error={descriptionError}
                  />
                </div>

                {/* --- Default Question Section for New Experience --- */}
                {newQuestion && (
                  <div className="form-group cm_questions cm_questions2 mt-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <label>Question</label>
                      <span className="question_types me-0">
                        {(newQuestion.questionType === 3 || newQuestion.questionType === 4) && (
                          <Fragment>
                            <p>Is Other Option ?</p>
                            <div className="cm_swich_wrap">
                              <input
                                onChange={handleNewIsOtherOptionChange}
                                type="checkbox"
                                checked={newQuestion.isOtherOption === 1}
                              />
                              <span />
                            </div>
                          </Fragment>
                        )}

                        <p>Is Mandatory ?</p>
                        <div className="cm_swich_wrap">
                          <input
                            type="checkbox"
                            checked={newQuestion.isRequred === 1}
                            onChange={handleNewIsRequiredChange}
                          />
                          <span />
                        </div>

                        <CustomSelect
                          pHolder="Select Question Type"
                          value={getQuestionType(newQuestion.questionType)}
                          onChange={handleNewQuestionTypeChange}
                          options={questionTypes}
                        />
                      </span>
                    </div>

                    {newQuestion.questionType ? (
                      <div className="cm_ques">
                        <CustomTextarea
                          pHolder="Question*"
                          value={newQuestion.title}
                          change={(e) => handleNewQuestionChange(e, 'title')}
                        />
                        <CustomTextarea
                          pHolder="Sub Title"
                          value={newQuestion.subTitle}
                          change={(e) => handleNewQuestionChange(e, 'subTitle')}
                        />
                      </div>
                    ) : null}

                    {(newQuestion.questionType === 2 ||
                      newQuestion.questionType === 3 ||
                      newQuestion.questionType === 4) && (
                        <div className="cm_options mt-2">
                          {newQuestion.options.length ? (
                            <ul>
                              {newQuestion.options.map((itm, j) => (
                                <li key={j}>
                                  {itm.opt}{' '}
                                  <i
                                    className="icon-close"
                                    onClick={() => handleRemoveNewOption(j)}
                                  />
                                </li>
                              ))}
                            </ul>
                          ) : null}

                          <div className="d-flex align-items-center">
                            <input
                              type="text"
                              className={`form-control ${newQuestion.optionValErr ? 'is-invalid' : ''
                                }`}
                              placeholder="Add Option"
                              value={newQuestion.optionVal}
                              onChange={handleNewOptionValChange}
                            />
                            {newQuestion.optionValErr && (
                              <h6>{newQuestion.optionValErr}</h6>
                            )}
                            <div>
                              <span
                                style={{ minWidth: '150px', marginLeft: '20px' }}
                                className="btn btn-outline-primary btn-sm"
                                onClick={handleAddNewOption}
                              >
                                <i className="icon-plus" />
                                <small>Add</small>
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                )}
                {/* --- End Default Question Section --- */}

                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button type="button" className="btn btn-gray" onClick={handleCancelEdit}>
                    Cancel
                  </button>
                  <button className="btn btn-primary" type="submit">
                    Save
                  </button>
                </div>
              </form>
            )}
          </Tab>
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
        <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={btnLoadeer}>{btnLoadeer ? 'Saving...' : 'Save All Changes'}</button>
      </Modal.Footer>
    </Modal>
  )
}
